module.exports = __webpack_public_path__ + "img/exclusive_02.ffdb6191.jpg";